export default __webpack_public_path__ + "static/media/details_icon.62cd2986.svg";